



















































import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapState } from 'vuex';
import { SUBMODULES_PATHS } from '../../store';
import { CONFIG_GETTERS_KEYS } from '../../store/config/config.const';
import { SEARCH_GETTERS_KEYS } from '../../store/search/search.const';

@Component({
  computed: {
    ...mapGetters(SUBMODULES_PATHS.config, {
      components: CONFIG_GETTERS_KEYS.components,
      config: CONFIG_GETTERS_KEYS.config,
      resultConfig: CONFIG_GETTERS_KEYS.partialsResultConfig
    }),
    ...mapGetters(SUBMODULES_PATHS.search, {
      showPartials: SEARCH_GETTERS_KEYS.showPartials
    }),
    ...mapState(SUBMODULES_PATHS.search, {
      banners: 'banners',
      promoteds: 'promoteds',
      isLoadingResults: 'loading',
      partialResults: 'partialResults',
      query: 'query'
    })
  }
})
export default class Partials extends Vue {}
